<template>
	<div>
		<transition name="fade">
			<vue-draggable-resizable
			class="element-position-lowerthird "
			:style="style"
			:class="className"
			v-if="status ==='preview' && isVideoInput"
			:draggable="status ==='preview' && !item.is_locked"
			:lock-aspect-ratio="isLockRatio"
			:resizable="status ==='preview' && !item.is_locked"
			:x="content.x"
			:y="content.y"
			:w="content.width"
			:h="content.height"
			@dragstop="onDragstop"
			@resizestop="onResizestop"
			@dragging="onDrag"
			@resizing="onResize"
			:preventActiveBehavior="true"
			:parent="false">
			<div :style="styleWithCroppingOuter">
				<div :style="styleWithCropping"
					class="element-position "
					:class="className">
					<video
						:muted="isPreviewMuted"
						:width="videoWidth"
						autoplay
						scrolling="no"
						ref="videoInput">
					</video>
				</div>
			</div>
			</vue-draggable-resizable>
		</transition>
		<transition name="fade">
			<div v-if="status ==='live' && isVideoInput" :style="styleOutlineLive">
				<div v-if="status ==='live' && isVideoInput" :style="styleWithCroppingOuter">
					<div :style="styleLive"
						v-if="status ==='live' && isVideoInput"
						class="element-position"
						:class="className">
							<video
								v-if="status ==='live' && isVideoInput"
								:muted="isMuted"
								:width="videoWidth"
								scrolling="no"
								autoplay
								ref="videoInput">
							</video>
					</div>
				</div>
			</div>
		</transition>
		<!-- @TODO: -->
		<!-- Video Element -->
	</div>
</template>

<script>
import RTC from 'detectrtc';
import VueDraggableResizable from 'vue-draggable-resizable';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';
import rundownItemsApi from '@/api/rundownItems';
import { duplicateVar } from '@/lib/helper';

export default {
	name: 'ElementVideoInput',
	props: {
		item: {
			type: Object,
		},
		status: {
			type: String,
		},
	},
	components: {
		'vue-draggable-resizable': VueDraggableResizable,
	},
	data() {
		return {
			videoOptions: [],
			width: window.screen.availWidth,
			height: window.screen.availHeight,
			localStream: null,
			localMute: false,
			localMutePreview: false,
			localItem: null,
		};
	},
	sockets: {
		connect() {
			this.activateSocket();
		},
		items_live_update(items) {
			for (let index = 0; index < items.length; index++) {
				const item = items[index];
				if (this.localItem.id === item.id) {
					const muted = this.content && this.content.isMuted ? this.content.isMuted : false;
					this.localMute = muted;
					const checkLivePlaying = !!(item.is_play_live && this.status === 'preview');
					this.localMutePreview = checkLivePlaying ? true : muted;
				}
			}
		},
		force_play_item(data) {
			if (this.localItem.id === data.id) {
				this.localItem = duplicateVar(data);
				if (this.content) {
					const deviceId = this.content && this.content.videoId ? this.content.videoId : '';
					const audioId = this.content && this.content.audioId ? this.content.audioId : '';
					this.dispatchActionNoStopStream(deviceId, audioId);
				}
			}
		},
		item_mute_update(data) {
			const status = data.status;
			const id = data.id;
			if (this.localItem.id === id) {
				const propsMuted = JSON.parse(status);
				this.localMute = propsMuted;
			}
		},
	},
	created() {
		this.localItem = duplicateVar(this.item);
		const muted = this.content && this.content.isMuted ? this.content.isMuted : false;
		this.localMute = muted;
		const checkLivePlaying = !!(this.localItem.is_play_live && this.status === 'preview');
		this.localMutePreview = checkLivePlaying ? true : muted;
		this.activateSocket();
	},
	watch: {
		item() {
			if (this.item) {
				this.localItem = duplicateVar(this.item);
			}
		},
	},
	beforeDestroy() {
		// if (this.status === 'live') {
		// 	if (this.content && this.content.onCompleteItem) {
		// 		this.onCompletePlay(this.content.onCompleteItem);
		// 	}
		// }
		this.stopStream();
	},
	destroyed() {
		this.stopStream();
	},
	mounted() {
		this.initDevices();
		if (this.content) {
			const deviceId = this.content && this.content.videoId ? this.content.videoId : '';
			const audioId = this.content && this.content.audioId ? this.content.audioId : '';
			this.dispatchAction(deviceId, audioId);
		}
	},
	methods: {
		hasProperty(obj, prop) {
			return Object.prototype.hasOwnProperty.call(obj, prop);
		},
		activateSocket() {
			this.$socket.client.emit('join', this.room);
		},
		savePosition(x, y) {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			const content = duplicateVar(this.content);
			content.x = x;
			content.y = y;
			// eslint-disable-next-line no-restricted-globals
			if (!x || isNaN(x)) {
				content.x = 0;
			} else {
				content.x = x;
			}
			// eslint-disable-next-line no-restricted-globals
			if (!y || isNaN(y)) {
				content.y = 0;
			// eslint-disable-next-line no-restricted-globals
			} else {
				content.y = y;
			}
			content.audioId = content.audioId ? content.audioId : '';
			content.videoId = content.videoId ? content.videoId : '';
			content.position = 'custom';
			const params = {
				content: JSON.stringify(content),
				editPreview: 1,
			};
			rundownItemsApi.update(this.localItem.id, params, callback, errorCallback);
		},
		saveSize(x, y, w, h) {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			const content = duplicateVar(this.content);
			content.x = x;
			content.y = y;
			content.width = w;
			content.height = h;
			content.position = 'custom';
			// eslint-disable-next-line no-restricted-globals
			if (!w || isNaN(w) || w < 75) {
				content.width = 75;
			} else {
				content.width = w;
			}
			if (!h || (h < 75 && !content.isRatio)) {
				content.height = 75;
			// eslint-disable-next-line no-restricted-globals
			} else if (!h || isNaN(h) || (h < 75 && content.isRatio)) {
				content.height = 42;
			} else {
				content.height = h;
			}
			// eslint-disable-next-line no-restricted-globals
			if (!x || isNaN(x)) {
				content.x = 0;
			} else {
				content.x = x;
			}
			// eslint-disable-next-line no-restricted-globals
			if (!y || isNaN(y)) {
				content.y = 0;
			// eslint-disable-next-line no-restricted-globals
			} else {
				content.y = y;
			}
			content.audioId = this.content.audioId ? this.content.audioId : '';
			content.videoId = this.content.videoId ? this.content.videoId : '';
			const params = {
				content: JSON.stringify(content),
				editPreview: 1,
			};
			rundownItemsApi.update(this.localItem.id, params, callback, errorCallback);
		},
		onDragstop(x, y) {
			this.savePosition(x, y);
		},
		onResizestop(left, top, w, h) {
			this.saveSize(left, top, w, h);
		},
		onDrag() {
		},
		onResize(x, y, width, height) {
			this.content.width = width;
			this.content.height = height;
		},
		initDevices() {
			const that = this;
			RTC.load(() => {
				RTC.MediaDevices.map((device) => {
					if (device.kind === 'videoinput') {
						that.videoOptions.push(device);
					}
					return device;
				});
			});
		},
		dispatchActionNoStopStream(deviceId, audioId) {
			const video = this.$refs.videoInput;
			if (video) {
				// this.stopStream();
				// if (deviceId) {
				if (deviceId && audioId) {
					this.playVideoWithSound(video, deviceId, audioId);
				}

				if (deviceId && !audioId) {
					this.playVideoOnly(video, deviceId, audioId);
				}
			}
			// }
		},
		dispatchAction(deviceId, audioId) {
			const video = this.$refs.videoInput;
			if (video) {
				this.stopStream();
				// if (deviceId) {
				if (deviceId && audioId) {
					this.playVideoWithSound(video, deviceId, audioId);
				}

				if (deviceId && !audioId) {
					this.playVideoOnly(video, deviceId, audioId);
				}
			}
			// }
		},
		attachSinkId(element, sinkId) {
			// eslint no-empty: "error"
			if (typeof element.sinkId !== 'undefined') {
				element.setSinkId(sinkId)
					.then(() => {
						// empty
					})
					.catch(() => {

					});
			} else {
				// empty
			}
		},
		playVideoOnly(element, deviceId) {
			navigator.mediaDevices.getUserMedia({
				video: {
					deviceId: deviceId ? { exact: deviceId } : undefined,

				},
				audio: false,
			}).then((stream) => {
				this.localStream = stream;
				// eslint-disable-next-line no-param-reassign
				element.srcObject = stream;
			});
		},
		playVideoWithSound(element, deviceId, audioId) {
			navigator.mediaDevices.getUserMedia({
				video: { deviceId: deviceId ? { exact: deviceId } : undefined },
				audio: { deviceId: audioId ? { exact: audioId } : undefined },
			}).then((stream) => {
				this.localStream = stream;
				this.attachSinkId(element, audioId);
				// eslint-disable-next-line no-param-reassign
				// element.volume = 1;
				// eslint-disable-next-line no-param-reassign
				element.srcObject = stream;
			});
		},
		stopStream() {
			if (this.localStream) {
				this.localStream.getTracks().forEach((track) => {
					track.stop();
				});
			}
		},
		onCompletePlay(itemId) {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			rundownItemsApi.playLive(itemId, callback, errorCallback);
		},
	},
	computed: {
		videoWidth() {
			return this.content && this.content.width ? this.content.width : 0;
		},
		videoHeight() {
			return this.content && this.content.height ? this.content.height : 0;
		},
		isLockRatio() {
			return this.content && this.content.isRatio ? this.content.isRatio : false;
		},
		content() {
			return this.localItem.content && this.localItem.content !== ''
				? JSON.parse(this.localItem.content) : {};
		},
		className() {
			return this.content.position ? this.content.position : '';
		},
		style() {
			const style = {};
			style.position = 'absolute';
			style.border = '0';
			style.zIndex = this.localItem.layer_index;
			const content = this.content;
			if (content.opacity) style.opacity = content.opacity;
			if (content.width) style.width = `${content.width}px`;
			if (content.height) style.height = `${content.height}px`;
			// if (content.y) style.top = `${content.y}px`;
			// if (content.x) style.left = `${content.x}px`;
			return style;
		},
		styleWithCroppingOuter() {
			const style = {};
			style.zIndex = this.localItem.layer_index;
			const content = this.content;
			if (content.opacity) style.opacity = content.opacity;
			if (content.width) style.width = `${content.width}px`;
			if (content.height) style.height = `${content.height}px`;
			if (content.isEnableBorder) {
				if (content.isEnableCrop) {
					const top = content.cropTop || 0;
					const bottom = content.cropBottom || 0;
					const left = content.cropLeft || 0;
					const right = content.cropRight || 0;
					style.display = 'inline-block';
					style.position = 'relative';
					style.boxSizing = 'border-box';
					style.background = content.borderColor || 0;
					style.clipPath = `inset(${top}px ${right}px ${bottom}px ${left}px)`;
					style.overflow = 'hidden';
				} else {
					style.display = 'inline-block';
					style.position = 'relative';
					style.boxSizing = 'border-box';
					style.background = content.borderColor || 0;
					style.clipPath = 'inset(0px 0px 0px 0px)';
					style.overflow = 'hidden';
				}
			}
			return style;
		},
		styleWithCropping() {
			const style = {};
			style.position = 'absolute';
			style.zIndex = this.localItem.layer_index;
			const content = this.content;
			if (content.opacity) style.opacity = content.opacity;
			if (content.isEnableCrop) {
				const thickness = content.borderThickness || 0;
				if (content.width) style.width = `${content.width - (thickness * 2)}px`;
				if (content.height) style.height = `${content.height - (thickness * 2)}px`;
				style.position = 'absolute';
				const top = content.cropTop || 0;
				const bottom = content.cropBottom || 0;
				const left = content.cropLeft || 0;
				const right = content.cropRight || 0;
				style.left = `${thickness}px`;
				style.top = `${thickness}px`;
				style.clipPath = `inset(${top}px ${right}px ${bottom}px ${left}px)`;
			} else {
				const thickness = content.borderThickness || 0;
				if (content.width) style.width = `${content.width - (thickness * 2)}px`;
				if (content.height) style.height = `${content.height - (thickness * 2)}px`;
				style.position = 'absolute';
				style.left = `${thickness}px`;
				style.top = `${thickness}px`;
				style.clipPath = 'inset(0px 0px 0px 0px)';
			}
			return style;
		},
		styleOutlineLive() {
			const style = {};
			style.zIndex = this.localItem.layer_index;
			style.position = 'absolute';
			const content = this.content;
			if (content.opacity) style.opacity = content.opacity;
			if (content.width) style.width = `${content.width}px`;
			if (content.height) style.height = `${content.height}px`;
			if (content.y) style.top = `${content.y}px`;
			if (content.x) style.left = `${content.x}px`;
			return style;
		},
		styleLive() {
			const style = {};
			style.position = 'absolute';
			style.border = '0';
			style.zIndex = this.localItem.layer_index;
			const content = this.content;
			if (content) {
				if (content.opacity) style.opacity = content.opacity;
				if (content.width) style.width = `${content.width}px`;
				if (content.height) style.height = `${content.height}px`;
				if (content.y) style.top = `${content.y}px`;
				if (content.x) style.left = `${content.x}px`;
				if (content.isEnableCrop) {
					const thickness = content.borderThickness || 0;
					if (content.width) style.width = `${content.width - (thickness * 2)}px`;
					if (content.height) style.height = `${content.height - (thickness * 2)}px`;
					style.position = 'absolute';
					const top = content.cropTop || 0;
					const bottom = content.cropBottom || 0;
					const left = content.cropLeft || 0;
					const right = content.cropRight || 0;
					style.left = `${thickness}px`;
					style.top = `${thickness}px`;
					style.clipPath = `inset(${top}px ${right}px ${bottom}px ${left}px)`;
				} else {
					const thickness = content.borderThickness || 0;
					if (content.width) style.width = `${content.width - (thickness * 2)}px`;
					if (content.height) style.height = `${content.height - (thickness * 2)}px`;
					style.position = 'absolute';
					style.left = `${thickness}px`;
					style.top = `${thickness}px`;
					style.clipPath = 'inset(0px 0px 0px 0px)';
				}
			}
			return style;
		},
		isPreviewMuted() {
			return this.localMutePreview;
		},
		isVideoInput() {
			return this.localItem.type === 'video_input';
		},
		room() {
			const room = `rundown_${this.slug}`;
			return room;
		},
		isMuted() {
			return this.localMute;
		},
	},

};
</script>
